const autoNgTemplateLoaderTemplate1 = require('./storidgeSnapshotsDatatable.html');

angular.module('shbdeployer.integrations.storidge').component('storidgeSnapshotsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
  },
});
